import {Routes} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {TeamsComponent} from './pages/teams/teams.component';
import {TransfersComponent} from './pages/transfers/transfers.component';
import {PageNotFoundComponent} from './pages/page-not-found/page-not-found.component';
import {StandingsComponent} from './pages/standings/standings.component';
import {SignUpV2Component} from './pages/teams/sign-up-v2/sign-up-v2.component';
import {ngxPermissionsGuard} from 'ngx-permissions';
import {PlayerRegistrationComponent} from "./pages/teams/player-registration/player-registration.component";
import {InviteMembersComponent} from "./pages/teams/invite-members/invite-members.component";
import {ValidateMyAccountComponent} from "./pages/validate-my-account/validate-my-account.component";
import {InviteTeammatesComponent} from "./pages/invite-teammates/invite-teammates.component";
import {GamesV2Component} from "./pages/games/games-v2/games-v2.component";
import {PlayerSignUpComponent} from "./pages/teams/player-signup/player-sign-up.component";
import {SupportComponent} from "./pages/support/support.component";

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'validate-my-account', component: ValidateMyAccountComponent, title: 'validate_account.confirm' },
    { path: 'home', component: HomeComponent, title: 'nav.home' },
    { path: 'teams/sign-up', component: SignUpV2Component, title: 'nav.sign_up' },
    { path: 'teams/account', component: PlayerSignUpComponent, title: 'teams.player_signup.title' },
    { path: 'teams/:team_id/player-registration', component: PlayerRegistrationComponent, title: 'teams.player_registration.title' },
    { path: 'teams/:team_id/invite-members', component: InviteMembersComponent, title: 'nav.invite_members' },
    {
        path: 'standings',
        component: StandingsComponent,
        title: 'nav.standings',
        // canActivate: [ngxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: ['STANDINGS']
        //     }
        // },
    },
    {
        path: 'teams',
        component: TeamsComponent,
        title: 'nav.teams',
        // canActivate: [ngxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: ['TEAMS']
        //     }
        // },
    },
    {
        path: 'games',
        component: GamesV2Component,
        title: 'nav.games',
        // canActivate: [ngxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: ['GAMES']
        //     }
        // },
    },
    {
        path: 'transfers',
        component: TransfersComponent,
        title: 'nav.transfers',
        // canActivate: [ngxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: ['TRANSFERS']
        //     }
        // },
    },
    { path: 'playoffs', loadComponent: () => import('./pages/brackets/brackets-page.component').then(m => m.BracketsPageComponent), title: 'nav.playoffs' },
    { path: 'live-games', loadComponent: () => import('./pages/live-games/live-games.component').then(m => m.LiveGamesComponent), title: 'nav.live_games' },
    { path: 'invite-teammates', component: InviteTeammatesComponent, title: 'nav.invite_members' },
    { path: 'support/videos', component: SupportComponent, title: 'nav.support' },
    {
        path: 'admin',
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                // , 'BO-DATABASE', 'BO-DIVISIONS', 'BO-STANDINGS', 'BO-GAMES', 'BO-SCHEDULE', 'BO-GROUPS', 'BO-TRANSFERS', 'BO-PAYMENTS'
                only: ['BO-ACCESS']
            }
        },
        loadChildren: () => import('./pages/admin/admin.routes').then(m => m.ADMIN_ROUTES)
    },
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES)
    },
    {
        path: 'tourney/:entityCode',
        loadChildren: () => import('./pages/tournament/tournament.routes').then(m => m.TOURNAMENT_ROUTES)
    },
    { path: '**', component: PageNotFoundComponent, data: { isErrorPage: true }  }
];
